import React, { useState, useEffect } from "react";
import "./Footer.scss";
import { GoChevronDown } from "react-icons/go";

const Footer = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [visibility, setVisibility] = useState({
    categories: false,
    about: false,
    support: false,
    community: false,
    moreFromFiverr: false,
  });

  const handleToggle = (section) => {
    setVisibility((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const updateVisibilityBasedOnScreenSize = () => {
    if (window.innerWidth <= 1200) {
      setIsMobile(true);
      setVisibility({
        categories: false,
        about: false,
        support: false,
        community: false,
        moreFromFiverr: false,
      });
    } else {
      setIsMobile(false);
      setVisibility({
        categories: true,
        about: true,
        support: true,
        community: true,
        moreFromFiverr: true,
      });
    }
  };

  useEffect(() => {
    updateVisibilityBasedOnScreenSize(); // Call on mount to set the initial state

    window.addEventListener("resize", updateVisibilityBasedOnScreenSize);
    return () =>
      window.removeEventListener("resize", updateVisibilityBasedOnScreenSize);
  }, []);

  return (
    <div className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-cat">
            <div className="mobile-categorie">
              <h2>Categories</h2>
              {isMobile && (
                <GoChevronDown onClick={() => handleToggle("categories")} />
              )}
            </div>
            {(!isMobile || visibility.categories) && (
              <>
                <span>Graphics & Design</span>
                <span>Digital Marketing</span>
                <span>Writing & Translation</span>
                <span>Video & Animation</span>
                <span>Music & Audio</span>
                <span>Programming & Tech</span>
                <span>Data</span>
                <span>Business</span>
                <span>Lifestyle</span>
                <span>Photography</span>
                <span>Sitemap</span>
              </>
            )}
          </div>
          <div className="footer-cat">
            <div className="mobile-categorie">
              <h2>About</h2>
              {isMobile && (
                <GoChevronDown onClick={() => handleToggle("about")} />
              )}
            </div>
            {(!isMobile || visibility.about) && (
              <>
                <span>Press & News</span>
                <span>Partnerships</span>
                <span>Privacy Policy</span>
                <span>Terms of Service</span>
                <span>Intellectual Property Claims</span>
                <span>Investor Relations</span>
                <span>Contact Sales</span>
              </>
            )}
          </div>
          <div className="footer-cat">
            <div className="mobile-categorie">
              <h2>Support</h2>
              {isMobile && (
                <GoChevronDown onClick={() => handleToggle("support")} />
              )}
            </div>
            {(!isMobile || visibility.support) && (
              <>
                <span>Help & Support</span>
                <span>Trust & Safety</span>
                <span>Selling on Liverr</span>
                <span>Buying on Liverr</span>
              </>
            )}
          </div>
          <div className="footer-cat">
            <div className="mobile-categorie">
              <h2>Community</h2>
              {isMobile && (
                <GoChevronDown onClick={() => handleToggle("community")} />
              )}
            </div>
            {(!isMobile || visibility.community) && (
              <>
                <span>Customer Success Stories</span>
                <span>Community hub</span>
                <span>Forum</span>
                <span>Events</span>
                <span>Blog</span>
                <span>Influencers</span>
                <span>Podcast</span>
                <span>Affiliates</span>
                <span>Invite a Friend</span>
                <span>Become a Seller</span>
                <span>Community Standards</span>
              </>
            )}
          </div>
          <div className="footer-cat">
            <div className="mobile-categorie">
              <h2>More From Fiverr</h2>
              {isMobile && (
                <GoChevronDown onClick={() => handleToggle("moreFromFiverr")} />
              )}
            </div>
            {(!isMobile || visibility.moreFromFiverr) && (
              <>
                <span>Fiverr Business</span>
                <span>Community hub</span>
                <span>Forum</span>
                <span>Events</span>
                <span>Blog</span>
                <span>Influencers</span>
                <span>Podcast</span>
                <span>Affiliates</span>
                <span>Invite a Friend</span>
                <span>Become a Seller</span>
              </>
            )}
          </div>
        </div>

        <hr />
        <div className="footer-bottom">
          <div className="bottom-left">
            <span>Fiverr</span>
            <span className="copyright">
              © Fiverr International Ltd. {new Date().getFullYear()}
            </span>
          </div>
          <div className="bottom-right">
            <div className="social">
              <img src="/img/twitter.png" alt="" />
              <img src="/img/facebook.png" alt="" />
              <img src="/img/linkedin.png" alt="" />
              <img src="/img/pinterest.png" alt="" />
              <img src="/img/instagram.png" alt="" />
            </div>
            <div className="link">
              <img src="/img/language.png" alt="language" />
              <span>English</span>
            </div>
            <div className="link">
              <img src="/img/coin.png" alt="coin" />
              <span>USD</span>
            </div>
            <img src="/img/accessibility.png" alt="accessibility" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
